import { useHistory } from "react-router";
import { useState, useEffect } from "react";
import { useValue } from "../../../providers/ValueContext";
import MachineryCards from "../../../Components/ComponentsIndustry/MachineryCards";
import FooterButton from "../../../Components/ComponentsIndustry/FooterButton";
import CountFooter from "../../../Components/ComponentsIndustry/CountFooter";
import axios from "axios";


import {
  Container,
  SizeContainer,
  Title,
  ImgTitle,
  TitleSection,
  BackButton,
} from "./style";
import { useUser } from "../../../providers/UserContext";
import { useMachinery } from "../../../providers/MachineryContext"

const Machinery = () => {

  const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
  })
  const history = useHistory();

  const { machinaryFinancing, setMachinaryFinancing, entranceValue } = useValue();
  const {
    geradorEnergia,
    maquinaFrango,
    maquinaSalsichao,
    maquinaFrangoCorte,
    maquinaFries,
  } = useMachinery();

  let [total, setTotal] = useState(0);

  const { DoAForcedGet, industry, isNeededSetupIndustry } = useUser()

  useEffect(() => {
    DoAForcedGet()
  }, [])

  async function handlePay() {
    setMachinaryFinancing(machinaryFinancing + total);

    const data = industry
    data.batata = maquinaFries.amount;
    data.corteFrango = maquinaFrangoCorte.amount;
    data.frangoCarcaca = maquinaFrango.amount;
    data.linguica = maquinaSalsichao.amount;
    data.gerador = geradorEnergia.amount;

    if (entranceValue > total) {
      api.post(`${process.env.REACT_APP_BASE_URL}/industria/cadastrar`, data)
        .then(response => {
          DoAForcedGet()
          history.push("/employees")
        })
        .catch(error => console.log(error))
    } else {
      alert("Saldo Insuficiente")
    }
  };


  return (
    <Container>
      <SizeContainer>
        <Title>SUA INDÚSTRIA</Title>
        <TitleSection>
          <ImgTitle />
          <p>Linha de produção</p>
          <BackButton onClick={() => history.push(!isNeededSetupIndustry ? "/mapMenu" : "/mountFactory")} />
        </TitleSection>
        <MachineryCards total={total} setTotal={setTotal} />
        <CountFooter total={total} />
        <FooterButton text="Continuar" onHandle={handlePay} />
      </SizeContainer>
    </Container>
  );
};
export default Machinery;
